import { Controller } from '@hotwired/stimulus';
import { dispatchEvent, subscribeEvent, unsubscribeEvent, CustomEventNames } from '@shared/script/eventDispatcher';

type WishlistModalOpenEventDetail = {
    modalId: string;
    title: string;
};

export default class extends Controller {
    static targets = ['itemInfo'];

    declare itemInfoTarget: HTMLElement;

    connect(): void {
        subscribeEvent('wishlist-modal:open', this.replaceContent.bind(this));
    }

    disconnect(): void {
        unsubscribeEvent('wishlist-modal:open', this.replaceContent.bind(this));
    }

    replaceContent(detail: WishlistModalOpenEventDetail): void {
        this.itemInfoTarget.innerText = detail?.title;
        dispatchEvent(CustomEventNames.ModalOpen, { modalId: 'wishlistModal' });
    }
}
